webpackJsonp([169559349407212],{

/***/ 225:
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Creates an array of elements split into groups the length of `size`.
	 * If `array` can't be split evenly, the final chunk will be the remaining
	 * elements.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to process.
	 * @param {number} [size=1] The length of each chunk
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the new array of chunks.
	 * @example
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 2);
	 * // => [['a', 'b'], ['c', 'd']]
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 3);
	 * // => [['a', 'b', 'c'], ['d']]
	 */
	function chunk(array, size, guard) {
	  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	    size = 1;
	  } else {
	    size = nativeMax(toInteger(size), 0);
	  }
	  var length = array ? array.length : 0;
	  if (!length || size < 1) {
	    return [];
	  }
	  var index = 0,
	      resIndex = 0,
	      result = Array(nativeCeil(length / size));
	
	  while (index < length) {
	    result[resIndex++] = baseSlice(array, index, (index += size));
	  }
	  return result;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = chunk;


/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(100);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(97);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(99);
	
	var _HelmetConstants = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(101));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Function borrowed from https://www.npmjs.com/package/sec-to-min
	 *
	 * Gatsby has a problem with npm modules written in ES6
	 *
	 * @param {number} seconds
	 */
	var secToMin = function secToMin(seconds) {
	  var secs = Math.round(seconds);
	
	  if (secs < 0) {
	    throw new Error('Seconds must be positive');
	  }
	
	  if (secs < 60) {
	    if (secs < 10) {
	      return '0:0' + secs;
	    }
	
	    return '0:' + secs;
	  }
	
	  var minuteDivisor = secs % (60 * 60);
	  var minutes = Math.floor(minuteDivisor / 60);
	
	  var secondDivisor = minuteDivisor % 60;
	  var remSecs = Math.ceil(secondDivisor);
	
	  if (remSecs < 10 && remSecs > 0) {
	    remSecs = '0' + remSecs;
	  }
	  if (remSecs === 0) {
	    remSecs = remSecs + '0';
	  }
	
	  var time = {
	    m: minutes,
	    s: remSecs
	  };
	
	  return time.m + ':' + time.s;
	};
	
	var Duration = function Duration(_ref) {
	  var seconds = _ref.seconds;
	  return _react2.default.createElement(
	    'p',
	    { className: 'has-text-grey-light' },
	    secToMin(seconds)
	  );
	};
	
	Duration.propTypes = {
	  seconds: _propTypes2.default.number.isRequired
	};
	
	exports.default = Duration;
	module.exports = exports['default'];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _popoverEmbedModule = __webpack_require__(219);
	
	var _popoverEmbedModule2 = _interopRequireDefault(_popoverEmbedModule);
	
	var _btn_play2x = __webpack_require__(261);
	
	var _btn_play2x2 = _interopRequireDefault(_btn_play2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var responsivePadding = {
	  padding: '56.25% 0 0 0',
	  position: 'relative'
	};
	
	var responsiveWrapper = {
	  height: '100%',
	  left: 0,
	  position: 'absolute',
	  top: 0,
	  width: '100%'
	};
	
	var embedStyle = {
	  height: '100%',
	  width: '100%'
	};
	
	var PopoverEmbed = function (_Component) {
	  _inherits(PopoverEmbed, _Component);
	
	  function PopoverEmbed() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopoverEmbed);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.playVideo = function () {
	      if (_this.video) {
	        _this.video.popover.showAndPlay();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PopoverEmbed.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var _window = window,
	        wistia = _window._wq;
	    var _props = this.props,
	        id = _props.video.hashed_id,
	        setPlayFn = _props.setPlayFn;
	
	    wistia.push({
	      id: id,
	      onReady: function onReady(video) {
	        _this2.video = video;
	      }
	    });
	    if (setPlayFn) {
	      setPlayFn(this.playVideo);
	    }
	  };
	
	  PopoverEmbed.prototype.render = function render() {
	    var _props2 = this.props,
	        className = _props2.className,
	        video = _props2.video;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_popoverEmbedModule2.default.PopoverEmbed, className) },
	      _react2.default.createElement(
	        'div',
	        { className: _popoverEmbedModule2.default.PopoverEmbed__btn, onClick: this.playVideo },
	        _react2.default.createElement('img', { alt: 'play video', src: _btn_play2x2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'wistia_responsive_padding', style: responsivePadding },
	        _react2.default.createElement(
	          'div',
	          { className: 'wistia_responsive_wrapper', style: responsiveWrapper },
	          _react2.default.createElement('div', {
	            className: (0, _classnames2.default)('playButton=false', 'popover=true', 'videoFoam=true', 'wistia_embed wistia_async_' + video.hashed_id),
	            style: embedStyle
	          })
	        )
	      )
	    );
	  };
	
	  return PopoverEmbed;
	}(_react.Component);
	
	PopoverEmbed.propTypes = {
	  className: _propTypes2.default.string,
	  setPlayFn: _propTypes2.default.func,
	  video: _propTypes2.default.shape({
	    hashed_id: _propTypes2.default.string.isRequired,
	    thumbnail: _propTypes2.default.shape({
	      url: _propTypes2.default.string.isRequired
	    }).isRequired
	  }).isRequired
	};
	
	exports.default = PopoverEmbed;
	module.exports = exports['default'];

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VideoProject = __webpack_require__(354);
	
	var _VideoProject2 = _interopRequireDefault(_VideoProject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoGrid = function VideoGrid(_ref) {
	  var projects = _ref.projects;
	  return _react2.default.createElement(
	    'div',
	    null,
	    Object.keys(projects).map(function (id) {
	      return _react2.default.createElement(_VideoProject2.default, { key: id, project: projects[id] });
	    })
	  );
	};
	
	VideoGrid.propTypes = {
	  projects: _propTypes2.default.objectOf(_propTypes2.default.shape({
	    id: _propTypes2.default.number.isRequired,
	    name: _propTypes2.default.string.isRequired,
	    media: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      thumbnail: _propTypes2.default.shape({
	        url: _propTypes2.default.string.isRequired
	      }).isRequired,
	      duration: _propTypes2.default.number.isRequired,
	      hashed_id: _propTypes2.default.string.isRequired,
	      name: _propTypes2.default.string.isRequired
	    })).isRequired
	  })).isRequired
	};
	
	exports.default = VideoGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Duration = __webpack_require__(182);
	
	var _Duration2 = _interopRequireDefault(_Duration);
	
	var _PopoverEmbed = __webpack_require__(183);
	
	var _PopoverEmbed2 = _interopRequireDefault(_PopoverEmbed);
	
	var _videoListModule = __webpack_require__(220);
	
	var _videoListModule2 = _interopRequireDefault(_videoListModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoListItem = function (_Component) {
	  _inherits(VideoListItem, _Component);
	
	  function VideoListItem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VideoListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.play = function () {
	      var playFn = function playFn() {};
	      if (_this.playFn) {
	        playFn = _this.playFn;
	      }
	      playFn();
	    }, _this.setPlayFn = function (fn) {
	      _this.playFn = fn;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  VideoListItem.prototype.render = function render() {
	    var _classNames;
	
	    var _props = this.props,
	        video = _props.video,
	        isGridItem = _props.isGridItem,
	        useEmbed = _props.useEmbed;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_videoListModule2.default.VideoListItem, (_classNames = {
	          'is-flex': !isGridItem
	        }, _classNames[_videoListModule2.default['VideoListItem--in-vertical']] = !isGridItem, _classNames[_videoListModule2.default['VideoListItem--in-grid']] = isGridItem, _classNames))
	      },
	      useEmbed ? _react2.default.createElement(_PopoverEmbed2.default, {
	        className: _videoListModule2.default.VideoListItem__thumbnail,
	        setPlayFn: this.setPlayFn,
	        video: video
	      }) : _react2.default.createElement('img', {
	        className: _videoListModule2.default.VideoListItem__thumbnail,
	        src: video.thumbnail.url
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _videoListModule2.default.VideoListItem__details },
	        _react2.default.createElement(
	          'p',
	          { className: _videoListModule2.default.VideoListItem__videoName, onClick: this.play },
	          video.name
	        ),
	        _react2.default.createElement(_Duration2.default, { seconds: video.duration })
	      )
	    );
	  };
	
	  return VideoListItem;
	}(_react.Component);
	
	VideoListItem.propTypes = {
	  isGridItem: _propTypes2.default.bool,
	  useEmbed: _propTypes2.default.bool,
	  video: _propTypes2.default.shape({
	    thumbnail: _propTypes2.default.shape({
	      url: _propTypes2.default.string.isRequired
	    }).isRequired,
	    duration: _propTypes2.default.number.isRequired,
	    hashed_id: _propTypes2.default.string,
	    name: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	
	VideoListItem.defaultProps = {
	  isGridItem: false,
	  useEmbed: false
	};
	
	exports.default = VideoListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(225);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _VideoListItem = __webpack_require__(184);
	
	var _VideoListItem2 = _interopRequireDefault(_VideoListItem);
	
	var _videoProjectModule = __webpack_require__(457);
	
	var _videoProjectModule2 = _interopRequireDefault(_videoProjectModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoProject = function VideoProject(_ref) {
	  var project = _ref.project;
	  var name = project.name,
	      media = project.media;
	
	  var chunks = (0, _lodash2.default)(media, 3);
	
	  return _react2.default.createElement(
	    'section',
	    { className: _videoProjectModule2.default.VideoProject },
	    _react2.default.createElement(
	      'h1',
	      {
	        className: (0, _classnames2.default)('has-text-weight-bold', _videoProjectModule2.default.VideoProject__heading)
	      },
	      name
	    ),
	    chunks.map(function (videos, i) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'columns', key: 'video-group-' + i },
	        videos.map(function (video, j) {
	          return _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)('column is-one-third box', _videoProjectModule2.default.VideoProject__video),
	              key: video.id + '-' + i + '-' + j
	            },
	            _react2.default.createElement(_VideoListItem2.default, { isGridItem: true, useEmbed: true, video: video })
	          );
	        })
	      );
	    })
	  );
	};
	
	VideoProject.propTypes = {
	  project: _propTypes2.default.shape({
	    id: _propTypes2.default.number.isRequired,
	    name: _propTypes2.default.string.isRequired,
	    media: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      thumbnail: _propTypes2.default.shape({
	        url: _propTypes2.default.string.isRequired
	      }).isRequired,
	      duration: _propTypes2.default.number.isRequired,
	      hashed_id: _propTypes2.default.string.isRequired,
	      name: _propTypes2.default.string.isRequired
	    })).isRequired
	  })
	};
	
	exports.default = VideoProject;
	module.exports = exports['default'];

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PopoverEmbed":"src-components-videos----popover-embed-module---PopoverEmbed---1MDsz","PopoverEmbed__btn":"src-components-videos----popover-embed-module---PopoverEmbed__btn---1NyvY","Popover_placeholder":"src-components-videos----popover-embed-module---Popover_placeholder---3KPRV"};

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"VideoListItem":"src-components-videos----video-list-module---VideoListItem---3nlRd","VideoListItem__videoName":"src-components-videos----video-list-module---VideoListItem__videoName---3ZMGS","VideoListItem--in-vertical":"src-components-videos----video-list-module---VideoListItem--in-vertical---3yAaW","VideoListItem__thumbnail":"src-components-videos----video-list-module---VideoListItem__thumbnail---3xxIK","VideoListItem__details":"src-components-videos----video-list-module---VideoListItem__details---1wWiY","VideoListItem--in-grid":"src-components-videos----video-list-module---VideoListItem--in-grid---KbftZ","spinAround":"src-components-videos----video-list-module---spinAround---3Y03K"};

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"VideoProject":"src-components-videos----video-project-module---VideoProject---sLLI0","VideoProject__heading":"src-components-videos----video-project-module---VideoProject__heading---314bR","VideoProject__video":"src-components-videos----video-project-module---VideoProject__video---2b_LW","spinAround":"src-components-videos----video-project-module---spinAround---3-P0F"};

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.groupByProject = undefined;
	
	var _lodash = __webpack_require__(39);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var groupByProject = exports.groupByProject = function groupByProject(videoEdges) {
	  return videoEdges.reduce(function (acc, _ref) {
	    var node = _ref.node;
	    var _node$project = node.project,
	        id = _node$project.id,
	        name = _node$project.name;
	
	
	    if (!acc[id]) {
	      acc[id] = { name: name, id: id, media: [] }; // eslint-disable-line no-param-reassign
	    }
	
	    var nextIndex = acc[id].media.length;
	
	    return (0, _lodash2.default)(acc, [id, 'media', '' + nextIndex], node);
	  }, {});
	};

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(98);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _VideoGrid = __webpack_require__(352);
	
	var _VideoGrid2 = _interopRequireDefault(_VideoGrid);
	
	var _videos = __webpack_require__(357);
	
	var _videosModule = __webpack_require__(460);
	
	var _videosModule2 = _interopRequireDefault(_videosModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getProjects(data) {
	  var GATSBY_WISTIA_POPULAR_VIDEOS_PROJECT_ID = ("3590411");
	  // We should exclude the popular videos project
	
	  var videos = data.allWistiaVideo.edges.filter(function (_ref) {
	    var video = _ref.node;
	    return video.project.id !== parseInt(GATSBY_WISTIA_POPULAR_VIDEOS_PROJECT_ID, 10);
	  });
	
	  return (0, _videos.groupByProject)(videos);
	}
	
	var Videos = function Videos(_ref2) {
	  var data = _ref2.data;
	  return _react2.default.createElement(
	    'section',
	    { className: (0, _classnames2.default)('section', _videosModule2.default.Videos) },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { title: 'Popular Videos | TeamGantt Support' },
	      _react2.default.createElement('meta', {
	        content: 'Watch these short videos, and start mastering the basics of TeamGantt',
	        name: 'description'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('container has-text-centered', _videosModule2.default.Videos__hero)
	      },
	      _react2.default.createElement(
	        'h1',
	        { className: (0, _classnames2.default)(_videosModule2.default.Videos__heading) },
	        'Popular Videos'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _videosModule2.default.Videos__summary },
	        'Watch these short videos, and start mastering the basics of TeamGantt'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'is-size-6' },
	        'Don\'t have a TeamGantt account?',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.teamgantt.com/signup?plan=free' },
	          'Sign up for free.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('container', _videosModule2.default.Videos__container) },
	      _react2.default.createElement(_VideoGrid2.default, { projects: getProjects(data) })
	    )
	  );
	};
	
	Videos.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = Videos;
	
	// eslint-disable-next-line
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Videos__hero":"src-pages----videos-module---Videos__hero---1mv_6","Videos__heading":"src-pages----videos-module---Videos__heading---3LNI-","Videos__summary":"src-pages----videos-module---Videos__summary---3IbOp","Videos__container":"src-pages----videos-module---Videos__container---2f8bE","spinAround":"src-pages----videos-module---spinAround---uzKIz"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-videos-js-ef9b779d59460e826098.js